<template>
    <div class="global-progress">
        <div class="global-progress__bar"
            :style="{'height': `${progress * 100}%`}"></div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../scss/design.scss';
    


    .global-progress {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: $color-progress-bar-background;
        border: 6px solid $color-progress-bar-border;
        border-radius: 999px;

        &__bar {
            border-radius: 999px;
            background-color: $color-progress-bar-indicator;
            box-shadow: inset 2px 2px 0 0 $color-progress-bar-indicator-highlight;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
        }
    }
</style>

<script>
export default {
    props: {
        /**
         * @description Decimal between 0 and 1
         */
        progress: {
            type: Number,
            default: 0
        }
    }
}
</script>